import { Link } from "react-router-dom";
import { Instagram, Youtube, MessageCircle } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_wp-go-live/artifacts/a5en3pve_Logo.jpg";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1F2547] text-[#F7F6FB] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-14 h-14 rounded-full bg-white overflow-hidden ring-2 ring-white/20">
              <img
                src={LOGO_URL}
                alt="Percept Academy logo"
                className="w-full h-full object-cover"
              />
            </span>
            <div>
              <div className="font-display font-black text-2xl">Percept Academy</div>
              <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#C7DCF7]">
                Step-up in the right direction
              </div>
            </div>
          </div>
          <p className="text-gray-400 max-w-md font-medium">
            Helping learners speak, write, and think in English with confidence.
            Modern coaching for the curious mind.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-[0.2em] mb-4 text-[#C7DCF7]">
            Explore
          </h4>
          <ul className="space-y-2 text-gray-300 font-medium">
            <li><Link to="/blogs" data-testid="footer-link-blogs" className="hover:text-[#C7DCF7]">Blogs</Link></li>
            <li><Link to="/videos" data-testid="footer-link-videos" className="hover:text-[#C7DCF7]">Videos</Link></li>
            <li><Link to="/worksheets" data-testid="footer-link-worksheets" className="hover:text-[#C7DCF7]">Worksheets</Link></li>
            <li><Link to="/courses" data-testid="footer-link-courses" className="hover:text-[#C7DCF7]">Courses</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-[0.2em] mb-4 text-[#C7DCF7]">
            Connect
          </h4>
          <div className="flex gap-3">
            <a href="https://www.youtube.com/@SmritiAsthana" target="_blank" rel="noopener noreferrer" data-testid="social-youtube" aria-label="Youtube" className="w-10 h-10 rounded-full bg-[#F7F6FB] text-[#1F2547] flex items-center justify-center hover:bg-[#C7DCF7]">
              <Youtube className="w-4 h-4" />
            </a>
            <a href="https://www.instagram.com/perceptacademy_?igsh=MWo1Y281c216N2p5OQ==" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" aria-label="Instagram" className="w-10 h-10 rounded-full bg-[#F7F6FB] text-[#1F2547] flex items-center justify-center hover:bg-[#C7DCF7]">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="https://wa.me/919968110261" target="_blank" rel="noopener noreferrer" data-testid="social-whatsapp" aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-[#F7F6FB] text-[#1F2547] flex items-center justify-center hover:bg-[#C7DCF7]">
              <MessageCircle className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-sm text-gray-400">
          <span>© {new Date().getFullYear()} Percept Academy. All rights reserved.</span>
          <span className="font-medium">Crafted with curiosity ✦</span>
        </div>
      </div>
    </footer>
  );
}
